export default __webpack_public_path__ + "static/media/b6d45e64826dd119886de7e47f9a1abd1581000880957.3c7cdb2f.webp";